import React from 'react';
import { modelClass } from '/imports/api/rarities';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const RaritiesPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: '_id', label: 'ID' }, { field: 'name', label: 'Name' }, { field: 'bbprice', label: 'Bulk Buy' }, { field: 'bsprice', label: 'Bulk Sell' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
